import { styled, Text } from "@sourceful/shared-components";
import { BlockContent } from "@lib/sanity-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import { CoreProductFields } from "@sourceful/shared-types";

const ProductDescriptionWrapper = styled("div", {
  marginTop: toRem(24),
  marginBottom: toRem(24),
  "& p": {
    fontWeight: "$latin_1_variable_light",
    letterSpacing: "-0.025em",
    fontSize: "$p2",
  },
});

const ProductDescription = ({ description }: { description: CoreProductFields["description"] }) => {
  const renderDescription = () => {
    if (!description) return null;

    if (typeof description === "string") {
      return <Text level={2}>{description}</Text>;
    }

    return <BlockContent value={description} />;
  };

  return <ProductDescriptionWrapper>{renderDescription()}</ProductDescriptionWrapper>;
};

export default ProductDescription;
